// config
import api from 'api';

const createNewTicket = async ({ ticketDto }) => {
  return await api.post(`price-negotiation/tickets/`, ticketDto);
};

export default createNewTicket;
